import React, { useState, useEffect } from 'react'
import {
  FormGroup,
  FormControl,
  InputLabel,
  Input,
  Button,
  styled,
  Typography,
} from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import { getRents, editRent } from '../Service/api'


const initialValue = {
  year: '',
  startingRent: '',
  effectiveRent: '',
}

const EditRentPage = () => {
  const [rent, setRent] = useState(initialValue)
  const { year, startingRent, effectiveRent } = rent
  const { id } = useParams()

  let navigate = useNavigate()

  useEffect(() => {
    loadRentDetails()
  }, [])

  const loadRentDetails = async () => {
    const response = await getRents(id)
    setRent(response.data)
  }

  const editRentDetails = async () => {
    const response = await editRent(id, rent)
    setRent(response.data)
    navigate('/all')
  }

  const onValueChange = (e) => {
    console.log(e.target.value)
    setRent({ ...rent, [e.target.name]: e.target.value })
  }

  return (
    <Container>
      <Typography variant='h4'>Edit Information</Typography>
      <FormControl>
        <InputLabel htmlFor='my-input'>Year</InputLabel>
        <Input
          onChange={(e) => onValueChange(e)}
          name='year'
          value={year}
          id='my-input'
          aria-describedby='my-helper-text'
        />
      </FormControl>
      <FormControl>
        <InputLabel htmlFor='my-input'>Starting Rent</InputLabel>
        <Input
          onChange={(e) => onValueChange(e)}
          name='startingRent'
          value={startingRent}
          id='my-input'
          aria-describedby='my-helper-text'
        />
      </FormControl>
      <FormControl>
        <InputLabel htmlFor='my-input'>Effective Rent</InputLabel>
        <Input
          onChange={(e) => onValueChange(e)}
          name='effectiveRent'
          value={effectiveRent}
          id='my-input'
          aria-describedby='my-helper-text'
        />
      </FormControl>
      <FormControl>
        <Button
          variant='contained'
          color='primary'
          onClick={() => editRentDetails()}
        >
          Edit Rent
        </Button>
      </FormControl>
    </Container>
  )
}

const Container = styled(FormGroup)`
  width: 50%;
  margin: 5% 0 0 25%;
  & > div {
    margin-top: 20px;
  }
`
export default EditRentPage


